import script from "./FiltersList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__